import {rootApiGroup} from '@integraciones_doc24/wehealthy-api';
import {ApiErrors} from '@integraciones_doc24/wehealthy-api/types/errors';
import {getSiteConfigEndpoint} from '@integraciones_doc24/wehealthy-api/root/content/getSiteConfig';
import {initApiConsumer} from '@urpi/consumer';
import {getBackEnd} from './backEndUrl';

const backendUrl = getBackEnd();

const apiConsumer = initApiConsumer<ApiErrors.All>(
  `${backendUrl}/api`,
  rootApiGroup,
);

const siteConfigEndPoint = apiConsumer(getSiteConfigEndpoint);

export const getSiteConfig = async () => {
  try {
    const siteConfig = await siteConfigEndPoint({
      query: {url: `${window.location.protocol}//${window.location.host}`},
    });
    return siteConfig;
  } catch (e) {
    return 'error';
  }
};
